import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, Tooltip } from '@mui/material';
import { ClassificationChip } from './classificationChip';
interface AutoClassificationProps {
  textOn?: string;
  isAutoClassificationOn: boolean;
  restartDetectionClicked: (e: React.MouseEvent<HTMLElement>) => void;
  editOverridesClicked: (e: React.MouseEvent<HTMLElement>) => void;
  setEditorOpen: (e: React.MouseEvent<HTMLElement>) => void;
  testId?: string;
  disabled?: boolean;
}
export function AutoClassification(props) {
  const $ = _c(10);
  const {
    isAutoClassificationOn
  } = props;
  const title = isAutoClassificationOn ? props.textOn ?? "Data classes were detected. Here are some samples:" : "Edited manually";
  const t0 = props.testId ?? "auto-classification-buttons";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Box className="font-light">{title}</Box>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <Stack direction="row" sx={t3}><AutoClassificationButtons {...props} /></Stack>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t0 || $[7] !== t2 || $[8] !== t4) {
    t5 = <Stack className="mb-4" direction="row" data-testid={t0} sx={t1}>{t2}{t4}</Stack>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function AutoClassificationButtons(props) {
  const $ = _c(25);
  if (!props.isAutoClassificationOn) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ClassificationChip status="off" label="Auto Classification is OFF" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== props) {
      t1 = e => props.restartDetectionClicked(e);
      $[1] = props;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        color: "var(--mui-palette-primary-main)",
        marginLeft: "12px"
      };
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Tooltip title="Resume"><i className="material-symbols-motion-play-outline-rounded text-xl" /></Tooltip>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t1) {
      t4 = <IconButton onClick={t1} sx={t2}>{t3}</IconButton>;
      $[5] = t1;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Divider sx={{
        height: "16px",
        marginRight: "24px",
        marginLeft: "24px"
      }} orientation="vertical" />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== props) {
      t6 = e_0 => props.editOverridesClicked(e_0);
      $[8] = props;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        color: "var(--mui-palette-primary-main)"
      };
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Tooltip title="Edit overrides"><i className="material-symbols-stylus-outline" /></Tooltip>;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] !== t6) {
      t9 = <IconButton onClick={t6} sx={t7}>{t8}</IconButton>;
      $[12] = t6;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t4 || $[15] !== t9) {
      t10 = <>{t0}{t4}{t5}{t9}</>;
      $[14] = t4;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    return t10;
  } else {
    let t0;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ClassificationChip status="on" label="Auto Classification is ON" />;
      $[17] = t0;
    } else {
      t0 = $[17];
    }
    let t1;
    if ($[18] !== props) {
      t1 = e_1 => {
        props.setEditorOpen(e_1);
      };
      $[18] = props;
      $[19] = t1;
    } else {
      t1 = $[19];
    }
    let t2;
    let t3;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        color: "var(--mui-palette-primary-main)",
        marginLeft: "12px"
      };
      t3 = <i className="mdi-stop-circle-outline" />;
      $[20] = t2;
      $[21] = t3;
    } else {
      t2 = $[20];
      t3 = $[21];
    }
    let t4;
    if ($[22] !== props.disabled || $[23] !== t1) {
      t4 = <>{t0}<Tooltip title="Pause & override"><span><IconButton color="primary" disabled={props.disabled} onClick={t1} sx={t2}>{t3}</IconButton></span></Tooltip></>;
      $[22] = props.disabled;
      $[23] = t1;
      $[24] = t4;
    } else {
      t4 = $[24];
    }
    return t4;
  }
}